import authClient from '@/plugins/axios/authClient'

export default {
  getFindId(phone) {
    return authClient.get(`/auth/find-id?phone=${phone}`)
  },
  postPasswordReset({ email, phone }) {
    return authClient.post('/auth/password/reset', { email, phone })
  },
  /**
   *
   * @param {
   * {
   *   "phone": "010-2441-8066",
   *   "verificationCode": "1351",
   *   "expirationTime": "2022-07-05T18:37:04.053506+09:00",
   *   "token": "aa24b5b9054a629c94d0324c23e8fbd8808b8406caf43c0dae5787c4706adb8d"
   * }
   * } params
   * @returns
   */
  postPasswordResetConfirm(params) {
    return authClient.post('/auth/password/reset/confirm', params)
  },
  /**
   *
   * @param {
   * {
   *   "email": "test6@funda.kr",
   *   "phone": "010-2441-8066",
   *   "new_password1": "hardpassword3#",
   *   "new_password2": "hardpassword3#",
   *   "verification": {
   *       "phone": "010-2441-8066",
   *       "verificationCode": "1351",
   *       "expirationTime": "2022-07-05T18:37:04.053506+09:00",
   *       "token": "aa24b5b9054a629c94d0324c23e8fbd8808b8406caf43c0dae5787c4706adb8d"
   *   }
   * }
   * } params
   * @returns
   */
  postPasswordResetChange(params) {
    return authClient.post('/auth/password/reset/change', params)
  },
}
